var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"tw:inline-flex tw:items-center tw:justify-center tw:min-w-6 tw:px-2 tw:py-0.5 tw:rounded-full tw:border tw:text-xs tw:font-medium",class:_setup.STYLES[_vm.severity]},[_vm._v(" "+_vm._s(_vm.count)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }